import {
  LayoutDashboard, FileText, ListChecks, ShoppingCart, PackagePlus,
  Wrench, Upload, AlertTriangle, History, BarChart3, Warehouse as WhIcon,
  ScrollText, Users as UsersIcon, Settings, Search, Recycle,
} from "lucide-react";

// roles: owner, partman, warehouse_receiving, warehouse_out, security_receiving, viewer
// Order follows the physical goods flow: SPK -> Required -> Procurement -> Receiving -> Warehouse -> Installed -> Salvage
export const MENU = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["owner", "partman", "warehouse_receiving", "warehouse_out", "viewer"] },
  { to: "/history", label: "History", icon: History, roles: ["owner", "partman", "warehouse_receiving", "warehouse_out", "viewer"] },
  { to: "/spk", label: "SPK", icon: FileText, roles: ["owner", "partman"] },
  { to: "/jobs", label: "Required Parts", icon: ListChecks, roles: ["owner", "partman", "viewer"] },
  { to: "/part-pesan", label: "Part Pesan", icon: ShoppingCart, roles: ["owner", "partman"] },
  { to: "/part-masuk", label: "Part Datang", icon: PackagePlus, roles: ["owner", "warehouse_receiving", "warehouse_out", "security_receiving"] },
  { to: "/receiving-history", label: "Part Datang", icon: PackagePlus, roles: ["partman"] },
  { to: "/warehouse", label: "Warehouse", icon: WhIcon, roles: ["owner", "partman", "warehouse_receiving", "warehouse_out"] },
  { to: "/receiving-history", label: "Recent Receiving", icon: History, roles: ["warehouse_receiving", "security_receiving"] },
  { to: "/part-terpasang", label: "Part Terpasang", icon: Wrench, roles: ["owner", "warehouse_out"] },
  { to: "/salvage", label: "Salvage", icon: Recycle, roles: ["owner", "partman", "warehouse_out", "viewer"] },
  { to: "/reports", label: "Reports", icon: BarChart3, roles: ["owner", "partman", "warehouse_out", "viewer"] },
  { to: "/unmatched", label: "Unmatched", icon: AlertTriangle, roles: ["owner", "partman"] },
  // AI Import / Legacy Migration DITUNDA — disembunyikan dari menu operasional (route & code tetap ada, non-destruktif)
  // { to: "/import", label: "AI Import", icon: Upload, roles: ["owner"] },
  { to: "/audit", label: "Audit Log", icon: ScrollText, roles: ["owner", "viewer"] },
  { to: "/users", label: "Users", icon: UsersIcon, roles: ["owner"] },
  { to: "/settings", label: "Settings", icon: Settings, roles: ["owner"] },
  { to: "/search", label: "Search Job", icon: Search, roles: ["warehouse_receiving", "warehouse_out", "security_receiving"] },
];

export function menuForRole(role) {
  const seen = new Set();
  return MENU.filter((m) => m.roles.includes(role)).filter((m) => {
    const k = m.to + m.label;
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}
